import cloneDeep from 'lodash/cloneDeep'
import type { OptionsDocument } from 'paintscout'
import { uuid } from '../../util'

export function copyEventTypes(args: { options: OptionsDocument; key: string }): OptionsDocument {
  const { options, key } = args
  const { eventTypes } = options.options

  const newItem = cloneDeep(eventTypes.values[key])
  newItem.key = uuid()
  newItem.label = `${newItem.label} (copy)`

  const order = eventTypes.order
  const orderIndex = order.indexOf(key)
  if (orderIndex !== -1) {
    order.splice(orderIndex + 1, 0, newItem.key)
  } else {
    order.push(newItem.key)
  }

  return {
    ...options,
    options: {
      ...options.options,
      eventTypes: {
        ...eventTypes,
        order,
        values: {
          ...(eventTypes?.values ?? {}),
          [newItem.key]: newItem
        }
      }
    }
  }
}
